module.exports = __webpack_public_path__ + "media/images/fonts/HKGroteskPro/HKGroteskPro-BoldItalic-18226a0eb8ca7b456287312316923fce.otf";